<template>

    <div class="scrollable-table">

        <table class="user-data table table-striped" id="user-data-table">
            <thead>
            <tr>
                <th v-on:click="sortBy('company_name')">
                    Company
                    <span class="fa-stack sort-stack fa-1x">
                      <i :class="showIcon('company_name', 'asc')" class="fa fa-sort-up fa-stack-1x"></i>
                      <i :class="showIcon('company_name', 'desc')" class="fa fa-sort-down fa-stack-1x"></i>
                    </span>
                </th>

                <th v-on:click="sortBy('name')">
                    Name
                    <span class="fa-stack sort-stack fa-1x">
                      <i :class="showIcon('name', 'asc')" class="fa fa-sort-up fa-stack-1x"></i>
                      <i :class="showIcon('name', 'desc')" class="fa fa-sort-down fa-stack-1x"></i>
                    </span>
                </th>

                <th v-on:click="sortBy('role')">
                    Role
                    <span class="fa-stack sort-stack fa-1x">
                      <i :class="showIcon('role', 'asc')" class="fa fa-sort-up fa-stack-1x"></i>
                      <i :class="showIcon('role', 'desc')" class="fa fa-sort-down fa-stack-1x"></i>
                    </span>
                </th>

                <th v-on:click="sortBy('created_at')">
                    Created
                    <span class="fa-stack sort-stack fa-1x">
                      <i :class="showIcon('created_at', 'asc')" class="fa fa-sort-up fa-stack-1x"></i>
                      <i :class="showIcon('created_at', 'desc')" class="fa fa-sort-down fa-stack-1x"></i>
                    </span>
                </th>

                <th v-on:click="sortBy('created_by')">
                    Created By
                    <span class="fa-stack sort-stack fa-1x">
                      <i :class="showIcon('created_by', 'asc')" class="fa fa-sort-up fa-stack-1x"></i>
                      <i :class="showIcon('created_by', 'desc')" class="fa fa-sort-down fa-stack-1x"></i>
                    </span>
                </th>
                <th v-on:click="sortBy('last_login')">
                    Last Login
                    <span class="fa-stack sort-stack fa-1x">
                      <i :class="showIcon('last_login', 'asc')" class="fa fa-sort-up fa-stack-1x"></i>
                      <i :class="showIcon('last_login', 'desc')" class="fa fa-sort-down fa-stack-1x"></i>
                    </span>
                </th>
                <th>
                    Actions
                    <span class="fa-stack sort-stack fa-1x"></span>
                </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(row) in this.sortedUserData">
                <td>{{ row.company }}</td>
                <td><strong>{{ row.name }} <span v-if="row.current"> (You)</span></strong></td>
                <td>{{ row.role }}</td>
                <td>{{ row.created_at_human }}</td>
                <td>{{ row.created_by }}</td>
                <td>{{ row.last_login_human }}</td>
                <td class="actions btn-group btn-group-sm" role="group">
                    <template v-if="row.can_edit">
                        <a :href="'/users/' + row.id + '/edit'"
                           :title="'Edit ' + row.name" class="btn btn-outline-secondary">
                            <i class="fas fa-user-edit"></i>
                        </a>
                        <a href="#"
                           :title="'Delete ' + row.name" class="btn btn-outline-danger"
                            @click.prevent="confirmDelete('/users/' + row.id + '/destroy')">
                            <i class="fas fa-trash"></i>
                        </a>
                    </template>
                </td>
            </tr>
            </tbody>
        </table>

        <LaravelVuePagination
            :data="rawData.paginator"
            :limit="3"
            :align="'center'"
            @pagination-change-page="changePage"
        />

    </div>

</template>

<script>
import LaravelVuePagination from 'laravel-vue-pagination'

export default {

    components: { LaravelVuePagination },

    props: ['currentSort', 'currentSortDir', 'rawData'],

    data: function () {
        return {
            sort: {
                by: this.currentSort,
                direction: this.currentSortDir,
            }
        }
    },

    computed: {
        sortedUserData: function () {
            return this.rawData.formattedData
        },
    },

    methods: {
        showIcon (column, direction) {
            return (column === this.sort.by && direction === this.sort.direction) ? 'active' : ''
        },

        sortBy(column) {
            if (column === this.sort.by) {
                this.sort.direction = (this.sort.direction === 'desc') ? 'asc' : 'desc'
            }

            this.sort.by = column
            this.$emit('update:sort', this.sort)
        },

        changePage: function(page) {
            this.$emit('page:set', page)
        },

        confirmDelete(deletePath) {
            $('#delete-confirm-modal').modal('show')

            document.querySelector('#delete-confirm').href = deletePath
        }
    }
}
</script>
